const getColor = (value) => {
  if (Number(value) >= 1) {
    return {
      background: 'rgba(68, 193, 152, 1)',
      color: '#fff'
    }
  } else if (Number(value) >= 0.75) {
    return {
      background: 'rgba(68, 193, 152, 1)',
      color: '#fff'
    }
  } else if (Number(value) >= 0.6) {
    return {
      background: 'rgba(187, 247, 208, 1)',
      color: '#000'
    }
  } else if (Number(value) >= 0.45) {
    return {
      background: 'rgba(220, 252, 231, 1)',
      color: '#000'
    }
  } else if (Number(value) >= 0.35) {
    return {
      background: 'rgba(254, 240, 138, 1)',
      color: '#000'
    }
  } else if (Number(value) >= 0.25) {
    return {
      background: 'rgba(254, 249, 195, 1)',
      color: '#000'
    }
  } else if (Number(value) >= 0.1) {
    return {
      background: 'rgba(254, 252, 232, 1)',
      color: '#000'
    }
  } else if (Number(value) >= 0.00001) {
    return {
      background: '#FFFBEB',
      color: '#000'
    }
  } else
    return {
      background: 'transparent',
      color: '#000'
    }
}

export const columnData = [
  {
    key: 'statDate',
    title: '日期',
    width: 120,
    index: 1,
    sortable: true,
    fixed: 'left',
    always: 'pitcher,summary,language'
  },
  {
    key: 'person',
    title: '优化师',
    width: 100,
    only: 'pitcher',
    always: 'pitcher',
  },
  {
    key: 'playName',
    title: '短剧信息',
    width: 120,
    tooltip: true,
    tooltipMaxWidth: 200,
    only: 'pitcher,language',
    always: 'language',
    // render: (h,params)=>{
    //   return <div>
    //     {params.row.playId} - {params.row.playName}
    //   </div>
    // }
  },
  
  {
    key: 'playCnName',
    title: '中文主剧名称',
    width: 180,
    always: 'summary',
    tooltip:true,
    tooltipMaxWidth: 300
  },
  // {
  //   key: 'optimizer',
  //   title: '优化师代号简称',
  //   width: 180,
  //   sortable: true
  // },
  // {
  //   key: 'personDictId',
  //   title: '优化师ID',
  //   width: 80,
  //   sortable: true
  // },
  
  {
    key: 'langCn',
    title: '语言',
    width: 120,
    align: 'center',
    only: 'pitcher,language',
  },
  
  
  {
    key: 'cost',
    title: '消耗',
    index: 2,
    width: 110,
    sortable: true
  },
  
  {
    title: '新用户数',
    sortable: true,
    width: 120,
    index: '24',
    notFixed: true,
    key: 'userCountNew'
  },
  {
    title: '染色用户数',
    sortable: true,
    width: 120,
    notFixed: true,
    index: '25',
    key: 'userCountAll'
  },
  {
    title: '激活用户数',
    sortable: true,
    width: 120,
    notFixed: true,
    index: 3,
    key: 'activation'
  },
  {
    title: '新用户激活成本',
    sortable: true,
    width: 150,
    index: '26',
    key: 'activationCostNew'
  },
  {
    title: '染色用户激活成本',
    sortable: true,
    width: 160,
    index: '27',
    key: 'activationCostAll'
  },
  {
    key: 'activationCost',
    title: '激活成本',
    index: 4,
    width: 110,
    sortable: true
  },
  {
    key: 'payUserCostNew',
    title: '累计付费新用户成本',
    index: 5,
    width: 170,
    sortable: true
  },
  {
    key: 'payUserCostAll',
    title: '累计付费染色用户成本',
    index: 6,
    width: 180,
    sortable: true
  },
  {
    key: 'firstROI',
    title: '首日ROI',
    index: 13,
    needCalc: true,
    width: 120,
    sortable: true,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.firstROI)
          }}
        >
          {params.row.firstROI
            ? (Number(params.row.firstROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    key: 'thirdROI',
    title: '3日ROI',
    needCalc: true,
    width: 120,
    index: 14,
    sortable: true,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.thirdROI)
          }}
        >
          {params.row.thirdROI
            ? (Number(params.row.thirdROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    key: 'eighthROI',
    title: '8日ROI',
    index: 15,
    width: 120,
    needCalc: true,
    sortable: true,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.eighthROI)
          }}
        >
          {params.row.eighthROI
            ? (Number(params.row.eighthROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    key: 'fifthROI',
    title: '15日ROI',
    width: 130,
    index: 16,
    needCalc: true,
    sortable: true,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.fifthROI)
          }}
        >
          {params.row.fifthROI
            ? (Number(params.row.fifthROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    key: 'thirtyROI',
    title: '30日ROI',
    width: 130,
    needCalc: true,
    index: 17,
    sortable: true,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.thirtyROI)
          }}
        >
          {params.row.thirtyROI
            ? (Number(params.row.thirtyROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    key: 'sixtyROI',
    title: '60日ROI',
    width: 130,
    needCalc: true,
    index: 18,
    sortable: true,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.sixtyROI)
          }}
        >
          {params.row.sixtyROI
            ? (Number(params.row.sixtyROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    key: 'firstRecharge',
    title: '首日充值金额',
    width: 130,
    index: 7,
    sortable: true
  },
  {
    key: 'thirdRecharge',
    title: '3日充值金额',
    width: 140,
    index: 8,
    sortable: true
  },
  {
    key: 'eighthRecharge',
    title: '8日充值金额',
    width: 140,
    index: 9,
    sortable: true
  },
  {
    key: 'fifthRecharge',
    title: '15日充值金额',
    width: 140,
    index: 10,
    sortable: true
  },
  {
    key: 'thirtyRecharge',
    title: '30日充值金额',
    width: 140,
    index: 11,
    sortable: true
  },
  {
    key: 'sixtyRecharge',
    title: '60日充值金额',
    width: 140,
    index: 12,
    sortable: true
  },
  {
    key: 'threeTimesGrowth',
    title: '3日增长倍数',
    width: 140,
    index: 19,
    sortable: true
  },
  {
    key: 'eightTimesGrowth',
    title: '8日增长倍数',
    width: 140,
    index: 20,
    sortable: true
  },
  {
    key: 'fifthTimesGrowth',
    title: '15日增长倍数',
    width: 140,
    index: 21,
    sortable: true
  },
  {
    key: 'thirtyTimesGrowth',
    title: '30日增长倍数',
    width: 140,
    index: 22,
    sortable: true
  },
  {
    key: 'sixtyTimesGrowth',
    title: '60日增长倍数',
    width: 140,
    index: 23,
    sortable: true
  }
]
